import defaultSolidImg from './images/solid/default.png'
import hoverSolidImg from './images/solid/hovered.png'
import activeSolidImg from './images/solid/active.png'
import focusedSolidImg from './images/solid/focused.png'

import defaultOutlinedImg from './images/outlined/default.png'
import hoverOutlinedImg from './images/outlined/hovered.png'
import activeOutlinedImg from './images/outlined/active.png'
import focusedOutlinedImg from './images/outlined/focused.png'

export const solidImages = {
    defaultSolidImg: { id: 1, src: defaultSolidImg, title: 'foo', description: 'bar' },
    hoverSolidImg: { id: 2, src: hoverSolidImg, title: 'foo', description: 'bar' },
    activeSolidImg: { id: 3, src: activeSolidImg, title: 'foo', description: 'bar' },
    focusedSolidImg: { id: 4, src: focusedSolidImg, title: 'foo', description: 'bar' },
};

export const outlinedImages = {
    defaultOutlinedImg: { id: 1, src: defaultOutlinedImg, title: 'foo', description: 'bar' },
    hoverOutlinedImg: { id: 2, src: hoverOutlinedImg, title: 'foo', description: 'bar' },
    activeOutlinedImg: { id: 3, src: activeOutlinedImg, title: 'foo', description: 'bar' },
    focusedOutlinedImg: { id: 4, src: focusedOutlinedImg, title: 'foo', description: 'bar' },
};
